import { useEffect, Fragment } from "react";
import { Tabs } from "antd";
import RouterTestC from "./RouterState/RouterTest";
import BulkConfigC from "./Setting/BulkConfigC";
import { useTranslation } from "react-i18next";
import DeviceTableC from "./Device/DeviceTableC";
import { setTab, setDeviceIdToGetConfig } from "./store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setEdittingInterface } from "./Setting/settingSlice";

// /overview 的 index
const { TabPane } = Tabs;
// const { Option } = Select;

const Topology = () => {
  const disp = useAppDispatch();
  const { tab } = useAppSelector((state) => state.topology);
  const { t } = useTranslation();

  const Tabcallback = (value: string) => {
    disp(setTab(value));
    disp(setDeviceIdToGetConfig(undefined));
  };

  useEffect(() => {
    disp(setTab("1"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Tabs
        onChange={(value) => {
          Tabcallback(value);
          disp(setEdittingInterface([]));
        }}
        activeKey={tab}
        type="card"
      >
        <TabPane tab={t("ISMS.Device")} key={"1"}>
          {tab === "1" && <DeviceTableC />}
        </TabPane>
        <TabPane tab={t("ISMS.Status")} key={"2"}>
          {tab === "2" && <RouterTestC />}
        </TabPane>
        <TabPane tab={t("ISMS.Setting")} key={"3"}>
          {tab === "3" && <BulkConfigC />}
        </TabPane>
      </Tabs>
    </Fragment>
  );
};

export default Topology;
